// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2EZTf","label":"Category_label__35joI","content":"Category_content__2yxNC","header":"Category_header__3yJpx","location":"Category_location__OAMRs"};